import { useState } from "react";
import { motion, useMotionValueEvent, useScroll, useSpring, useTransform } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { COIN_IMG, scrollToId } from "@/data";

export default function ScrollCompanion() {
  const { scrollY } = useScroll();
  const [show, setShow] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => setShow(v > 500));
  const rotate = useSpring(useTransform(scrollY, [0, 10000], [0, 1080]), {
    stiffness: 60,
    damping: 20,
  });

  return (
    <motion.button
      initial={false}
      animate={show ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, scale: 0, y: 30 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      style={{ pointerEvents: show ? "auto" : "none" }}
      onClick={() => scrollToId("#top")}
      className="group fixed bottom-6 left-5 z-[70] flex items-center gap-3"
      data-testid="scroll-companion"
      aria-label="$TATE — back to top"
    >
      <motion.div
        style={{ rotate }}
        className="relative"
      >
        <motion.div
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
        >
          <div className="absolute inset-0 rounded-full bg-[#E5A93C] opacity-30 blur-md transition-opacity duration-300 group-hover:opacity-60" />
          <img
            src={COIN_IMG}
            alt=""
            className="relative h-14 w-14 rounded-full border-2 border-[#E5A93C] object-cover shadow-[0_0_24px_rgba(229,169,60,0.35)] transition-transform duration-300 group-hover:scale-110 sm:h-16 sm:w-16"
            draggable="false"
          />
        </motion.div>
      </motion.div>
      <span className="glass hidden items-center gap-1.5 rounded-full border border-[rgba(229,169,60,0.4)] px-3.5 py-2 font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#F6C85F] opacity-0 transition-all duration-300 group-hover:opacity-100 sm:flex">
        <ArrowUp className="h-3 w-3" />
        $TATE
      </span>
    </motion.button>
  );
}
